import ConfigurationRuleTestSimulationSection from '../../../sections/AdminDashboard/Configuration/ConfigurationRuleTestSimulation';

const ConfigurationRuleTestSimulation = () => <ConfigurationRuleTestSimulationSection />;

export default ConfigurationRuleTestSimulation;
